import { useMenuStore } from "../zustand/store/useMenuStore";
import useQueryLinkNavigate from "./useQueryLinkNavigate";
import '../css/common.css';

/**
 * @DynamicStyleHook 메뉴에 따라 달라지는 배경색에 맞춘 동적 색상 훅
 <sample>
 -- useDynamicStyle import 후 필요한 색상만 꺼내와서 사용하기
    import { useDynamicStyle } from "../hooks/useDynamicStyle";
    const { hoverBackColor, fontColor, darkBackColor } = useDynamicStyle();
 */

export const useDynamicStyle = () => {
    
    const { isHome } = useQueryLinkNavigate();
    const clickedCategory = useMenuStore((state) => state.clickedCategory);

    // clickedCategory === 9(관리 메뉴) / 3(표준) / 21(외상)
    // 기본 배경색
    const backColor =
        clickedCategory === 3
        ? 'bg_st_bg'
        : clickedCategory === 21
        ? 'bg_tr_bg'
        : (clickedCategory === 9 || isHome)
        ? 'bg_ho_bg'
        : '';

    // 연한 배경색
    const lightBackColor =
        clickedCategory === 3
        ? 'bg_st_odd'
        : clickedCategory === 21
        ? 'bg_tr_odd'
        : 'bg_ho_odd';

    // primary 배경색
    const primaryBackColor = 
        clickedCategory === 3
        ? 'bg_st_primary'
        : clickedCategory === 21 
        ? 'bg_tr_primary'
        : 'bg_ho_primary';

    // gray 배경색
    const grayBackColor =
        clickedCategory === 3
        ? 'bg_st_soft'
        : clickedCategory === 21 
        ? 'bg_tr_soft'
        : 'bg_ho_soft';

    // 진한 배경색
    const darkBackColor = 
        clickedCategory === 3
        ? 'bg_st_dark'
        : clickedCategory === 21 
        ? 'bg_tr_dark'
        : 'bg_ho_dark';

    // hover시 기본 배경색
    const hoverBackColor =
        clickedCategory === 3
        ? 'hover_st_bg'
        : clickedCategory === 21
        ? 'hover_tr_bg'
        : 'hover_ho_bg';

    // hover시 primary 배경색
    const hoverPrimaryBackColor = 
        clickedCategory === 3
        ? 'hover_st_primary_bg'
        : clickedCategory === 21 
        ? 'hover_tr_primary_bg'
        : 'hover_ho_primary_bg';

    // hover시 gray 배경색
    const hoverGrayBackColor =
        clickedCategory === 3
        ? 'hover_st_soft_bg'
        : clickedCategory === 21 
        ? 'hover_tr_soft_bg'
        : 'hover_ho_soft_bg';

    // hover시 진한 배경색
    const hoverDarkBackColor = 
        clickedCategory === 3
        ? 'hover_st_dark_bg'
        : clickedCategory === 21 
        ? 'hover_tr_dark_bg'
        : 'hover_ho_dark_bg';

    // 글자색
    const fontColor = 
        clickedCategory === 3
        ? 'st_color'
        : clickedCategory === 21
        ? 'tr_color'
        : 'ho_color';

    // 글자색
    const fontGrayColor = 
        clickedCategory === 3
        ? 'st_soft'
        : clickedCategory === 21
        ? 'tr_soft'
        : 'ho_soft';
    
    // hover시 글자색
        const hoverFontColor = 
        clickedCategory === 3 
        ? 'st_color_h' 
        : clickedCategory === 21 
        ? 'tr_color_h' 
        : 'ho_color_h';

    // hover시 밝은 글자색
        const hoverLightFontColor = 
        clickedCategory === 3 
        ? 'st_bright_color_h' 
        : clickedCategory === 21 
        ? 'tr_bright_color_h' 
        : 'ho_bright_color_h';
    
    // 연한 border
    const lightBorderColor =
        clickedCategory === 3
        ? 'st_line_border'
        : clickedCategory === 21
        ? 'tr_line_border'
        : (clickedCategory === 9 || isHome)
        ? 'ho_line_border'
        : '';

    // gray border
    const borderColorGray =
        clickedCategory === 3
        ? 'st_border_soft'
        : clickedCategory === 21
        ? 'tr_border_soft'
        : 'ho_border_soft';

    // 연한 그림자
    const lightShadowColor =
        clickedCategory === 3
        ? 'st_line_shadow'
        : clickedCategory === 21
        ? 'tr_line_shadow'
        : (clickedCategory === 9 || isHome)
        ? 'ho_line_shadow'
        : '';

    // 연한 border 그림자
    const lightBorderShadowColor =
        clickedCategory === 3
        ? 'st_line_border_shadow'
        : clickedCategory === 21
        ? 'tr_line_border_shadow'
        : (clickedCategory === 9 || isHome)
        ? 'ho_line_border_shadow'
        : '';

    // 연한 border 안쪽 그림자
    const lightBorderShadowInColor =
        clickedCategory === 3
        ? 'st_line_border_shadow_in'
        : clickedCategory === 21
        ? 'tr_line_border_shadow_in'
        : 'ho_line_border_shadow_in';

    // 진한 border 그림자
    const darkBorderShadowColor =
        clickedCategory === 3
        ? 'st_toast_color'
        : clickedCategory === 21
        ? 'tr_toast_color'
        : (clickedCategory === 9 || isHome)
        ? 'ho_toast_color'
        : '';

    // hover시 primary 그림자
    const primaryShadowColor =
        clickedCategory === 3
        ? 'hover_st_primary_shadow'
        : clickedCategory === 21
        ? 'hover_tr_primary_shadow'
        : 'hover_ho_primary_shadow';
        
    // 즐겨찾기 border
    const favBorderColor = 
        clickedCategory === 3
        ? 'st_fav_color'
        : clickedCategory === 21
        ? 'tr_fav_color'
        : 'ho_fav_color';

    // toast border
    const toastBorderColor = 
        clickedCategory === 3
        ? 'st_toast_color'
        : clickedCategory === 21
        ? 'tr_toast_color'
        : 'ho_toast_color';
    
    // detail sub title
    const subTitleBorder =
        clickedCategory === 3
        ? 'st_sub_title_boder'
        : clickedCategory === 21
        ? 'tr_sub_title_boder'
        : 'ho_sub_title_boder';

    // grid select cell style
    const selectGridCell =
        clickedCategory === 3
        ? 'st_select_cell'
        : clickedCategory === 21
        ? 'tr_select_cell'
        : 'ho_select_cell';

    return {
        backColor,
        hoverBackColor,
        fontColor,
        fontGrayColor,
        hoverFontColor,
        hoverLightFontColor,
        darkBackColor,
        hoverDarkBackColor,
        primaryBackColor,
        hoverPrimaryBackColor,
        lightBackColor,
        grayBackColor,
        hoverGrayBackColor,
        lightBorderColor,
        borderColorGray,
        lightShadowColor,
        lightBorderShadowColor,
        lightBorderShadowInColor,
        darkBorderShadowColor,
        primaryShadowColor,
        favBorderColor,
        toastBorderColor,
        subTitleBorder,
        selectGridCell
    };
};